import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as CheckSvg } from '../../assets/check-icon.svg';

export const CheckIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={CheckSvg} {...props} />;
};
